import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import FormSubmitButton from '../FormSubmitButton'
import ReportHeading from '../ReportHeading'
import TextInput from '../TextInput'

export default function ValuationProjectionForm({ location }) {
  console.log('ValuationProjectionForm rendered: ', location)

  let init = {
    settlementGroup: [],
    pop: '2000',
    sui: '2000',
    plaintiffsWith1Surgery: '1000',
    plaintiffsWith2Surgeries: '2000',
    plaintiffsWith3Surgeries: '3000',
    plaintiffsWith4plusSurgeries: '4000',
    percentageDiscount: '20',
    plaintiffsWithProtogen: '5000',
    plaintiffsWithBiologic: '6000'
  }

  const navigate = useNavigate()
  init = initialFormValues('ValuationProjectionForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))
  async function submitSearch() {
    submitFormValues('ValuationProjectionForm', navigate, inputs, 'reports.valuation_projection')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <ReportHeading title='Valuation Projection Report' showReportDate={false} widths={['0%', '100%', '0%']} />
            <tbody>
              <CustomSelectListInput label="Settlement Group" handleChange={handleInputChange} modelName="BosSci" entityName="settlement_group" name='settlementGroup' multiple={true} />
              <TextInput label='POP' name='pop' handleInputChange={handleInputChange} defaultValue={inputs.pop} />
              <TextInput label='SUI' name='sui' handleInputChange={handleInputChange} defaultValue={inputs.sui} />
              <TextInput label='Plaintiffs with 1 Surgery' name='plaintiffsWith1Surgery' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWith1Surgery} />
              <TextInput label='Plaintiffs with 2 Surgery' name='plaintiffsWith2Surgeries' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWith2Surgeries} />
              <TextInput label='Plaintiffs with 3 Surgery' name='plaintiffsWith3Surgeries' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWith3Surgeries} />
              <TextInput label='Plaintiffs with 4+ Surgery' name='plaintiffsWith4plusSurgeries' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWith4plusSurgeries} />
              <TextInput label='% Discount For Plaintiffs With BSC Implants After July 1, 2011' name='percentageDiscount' handleInputChange={handleInputChange} defaultValue={inputs.percentageDiscount} />
              <TextInput label='Plaintiffs With Protogen Implants' name='plaintiffsWithProtogen' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWithProtogen} />
              <TextInput label='Plaintiffs With Biologic Implants' name='plaintiffsWithBiologic' handleInputChange={handleInputChange} defaultValue={inputs.plaintiffsWithBiologic} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}

